package com.trevorwiebe.timesheet.admin.ownerOperator.presentation

import com.trevorwiebe.timesheet.core.domain.model.OwnerOperator

enum class OwnerOperatorFilter { ACTIVE, INACTIVE, DELETED }

data class OwnerOperatorsState(
    val ownerOperators: List<OwnerOperator> = emptyList(),
    val activeFilters: Set<OwnerOperatorFilter> = setOf(OwnerOperatorFilter.ACTIVE),
    val showAddEditDialog: Boolean = false,
    val editingOwnerOperator: OwnerOperator? = null,
    val isLoading: Boolean = false,
    val error: String? = null
) {
    // Keeps the repository's order — no re-sorting here.
    val displayedOwnerOperators: List<OwnerOperator>
        get() = ownerOperators.filter { ownerOperator ->
            activeFilters.any { filter ->
                when (filter) {
                    OwnerOperatorFilter.ACTIVE -> ownerOperator.active && !ownerOperator.deleted
                    OwnerOperatorFilter.INACTIVE -> !ownerOperator.active && !ownerOperator.deleted
                    OwnerOperatorFilter.DELETED -> ownerOperator.deleted
                }
            }
        }
}
